<template>
  <v-app
    :style="{
      background: setBackgoundBox(),
      'background-attachment': 'fixed !important',
    }"
  >
    <router-view />
  </v-app>
</template>

<script>
import { mapState } from "vuex";
import { adjustHslBrightness } from "../../config/general-function";

export default {
  name: "Blanklayout",
  created() {
    this.changeWebsiteFont(this.site?.display_setting?.app_font);
  },
  methods: {
    setBackgoundBox() {
      const _color = this.site?.display_setting?.background_color || null;
      const bg_url = this.site?.display_setting?.background_url || null;
      let _style = "#fafafa";
      _style = "#ffffff";
      if (
        this.site?.display_setting?.background_type == "color_gradient" &&
        _color
      ) {
        const darken = adjustHslBrightness(_color, -20);
        _style = `linear-gradient(120deg, ${_color}, ${darken}) !important`;
      }
      if (this.site?.display_setting?.background_type == "image" && bg_url) {
        _style = `url("${bg_url}") center / cover no-repeat !important`;
      }
      if (
        this.site?.display_setting?.background_type == "color_plain" &&
        _color
      ) {
        _style = _color;
      }
      return _style;
    },
    changeWebsiteFont(fontNames) {
      let fontName = "";
      if (Array.isArray(fontNames)) {
        fontName = fontNames.map((font) => `"${font}"`).join(", ");
      } else {
        fontName = fontNames;
      }
      let _fontName = fontName || "Default";
      if (["Default", '"Default"'].includes(_fontName)) {
        document.documentElement.style.setProperty("--dynamic-font", "");
      } else {
        document.documentElement.style.setProperty("--dynamic-font", _fontName);
      }
    },
  },
  computed: {
    ...mapState("defaultSystem", ["site", "customer"]),
  },
};
</script>
